var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        class: _vm.alertContainerClasses.concat([_vm.alertClass]),
        attrs: { role: _vm.withAlertRole ? "alert" : null },
      },
      [
        _c(
          "p",
          {
            staticClass: "alert",
            class: !_vm.boldTitle
              ? "ob1-alert-normal"
              : "" + _vm.noBackground
              ? " ob1-alert-nobackground"
              : "",
          },
          [
            _c("span", {
              class: ["alert-icon", _vm.alertIconClass],
              attrs: { "aria-hidden": "true" },
            }),
            _vm._v(" "),
            _c("span", {
              staticClass: "ob1-alert-title",
              class: !_vm.boldTitle ? "font-weight-normal" : "",
              attrs: {
                "data-cs-mask": _vm.anonymized ? "" : null,
                "data-test-id": _vm.dataTestId,
              },
              domProps: { innerHTML: _vm._s(_vm.title) },
            }),
          ]
        ),
        _vm._v(" "),
        _vm.text
          ? _c("div", { staticClass: "alert-content" }, [
              !_vm.collapseTitle
                ? _c("p", {
                    staticClass: "alert-text",
                    domProps: { innerHTML: _vm._s(_vm.text) },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.collapseTitle
                ? _c(
                    "button",
                    {
                      class: [
                        "ob1-link-arrow",
                        "ob1-link-dark",
                        "collapsed",
                        _vm.buttonClass,
                      ],
                      attrs: {
                        id: _vm.collapseId + "-header",
                        type: "button",
                        "data-bs-toggle": "collapse",
                        "data-bs-target": "#" + _vm.collapseId + "-text",
                        "aria-expanded": "false",
                        "aria-controls": _vm.collapseId + "-text",
                      },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.collapseTitle) +
                          "\n            "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.collapseTitle
                ? _c("div", {
                    staticClass: "collapse",
                    attrs: {
                      id: _vm.collapseId + "-text",
                      "aria-labelledby": _vm.collapseId + "-header",
                    },
                    domProps: { innerHTML: _vm._s(_vm.text) },
                  })
                : _vm._e(),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.items
          ? _c(
              "div",
              { staticClass: "alert-content" },
              [
                _c("BulletList", {
                  attrs: { "no-style": false, texts: _vm.items },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.withButton
          ? _c("div", { staticClass: "alert-content" }, [
              _c("a", {
                staticClass: "btn btn-secondary",
                attrs: { href: _vm.urlButton },
                domProps: { innerHTML: _vm._s(_vm.labelButton) },
              }),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.$slots.content
          ? _c("div", { staticClass: "alert-content" }, [_vm._t("content")], 2)
          : _vm._e(),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }